<script setup>
import CompraListItems from "@components/shopping_cart/CompraListItems.vue";
import { useShoppingCartStore } from "@composables/use_shopping_cart_store";
import { useRouter } from "vue-router";
import { onMounted, ref } from "vue";
import {
  encriptar,
  desencriptar,
  encriptarCampo,
} from "@composables/use_encript.js";

const router = useRouter();

const { shoppingCartItems, shoppingCartTotal, tipoPago, idVenta } =
  useShoppingCartStore();

const emit = defineEmits(["oncloseshoppingcart", "onProcessCart"]);

function onClose() {
  let btnMP = document.getElementById("btnMP");
  if (btnMP) {
    btnMP.classList.remove("disabled");
  }
  let btnOtrosPagos = document.getElementById("btnOtrosPagos");
  if (btnOtrosPagos) {
    btnMP.classList.remove("disabled");
  }
  console.log("shopping cart modal close");
  emit("oncloseshoppingcart");
}

onMounted(() => {
  idVenta.value =
    desencriptar(localStorage.getItem(encriptarCampo("saleId"))) !== ""
      ? desencriptar(localStorage.getItem(encriptarCampo("saleId")))
      : "";
});

function number_format(number) {
  return Number(number).toLocaleString("es-AR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
</script>

<template>
  <div class="dialog-dismiss" @click="onClose">
    <div
      class="dialog-container"
      @click.stop
      style="max-height: 100%; overflow-y: auto"
    >
      <!-- Thank You Hero Section -->
      <div class="flex flex-col items-center text-center px-4 pt-8 pb-4">
        <div class="w-16 h-16 bg-emerald-50 rounded-full flex items-center justify-center mb-4 text-3xl shadow-inner animate-bounce">
          🎉
        </div>
        <h2 class="text-2xl sm:text-3xl font-black text-slate-800 mb-2 tracking-tight">¡Muchas gracias por tu compra!</h2>
        <p class="text-slate-500 text-sm sm:text-base max-w-md">Tu pedido ha sido recibido y estamos listos para procesarlo una vez que se complete el pago.</p>
      </div>

      <!-- Order Info Bar -->
      <div class="mx-4 sm:mx-8 px-6 py-4 bg-slate-50 rounded-2xl border border-slate-100 flex flex-wrap items-center justify-between gap-4 mt-2">
         <div class="flex items-center gap-3">
           <div class="w-10 h-10 bg-white rounded-xl shadow-sm flex items-center justify-center text-xl">
             {{ tipoPago == 'OtrosMedios' ? '🏦' : '💳' }}
           </div>
           <div class="text-left">
             <p class="text-[10px] font-bold text-slate-400 uppercase tracking-widest leading-none mb-1">Método de pago</p>
             <p class="text-sm font-bold text-slate-700">
               {{ tipoPago == 'OtrosMedios' ? 'Otros medios de Pago' : 'Mercado Pago' }}
             </p>
           </div>
         </div>
         <div v-if="idVenta != ''" class="text-right">
           <p class="text-[10px] font-bold text-slate-400 uppercase tracking-widest leading-none mb-1">Orden No.</p>
           <p class="text-base font-black text-red-600">#{{ idVenta }}</p>
         </div>
      </div>

      <!-- Payment Reminder Alert -->
      <div
        class="mx-4 sm:mx-8 mt-4 p-4 rounded-2xl flex items-start gap-3 border transition-all"
        :class="tipoPago === 'OtrosMedios' ? 'bg-amber-50 border-amber-200 text-amber-800' : 'bg-emerald-50 border-emerald-200 text-emerald-800'"
      >
        <span class="text-xl">⚠️</span>
        <div class="text-[13px] font-medium leading-relaxed">
          <strong class="block mb-0.5">Pendiente de Pago:</strong>
          Recuerda que aún debes realizar el pago para que podamos entregarte la compra. 
          Un asistente se comunicará con vos para coordinar los detalles finales.
        </div>
      </div>


      <div class="row mx-2 pt-3">
        <div class="col-12 col-sm-8 col-md d-md-block pb-1 d-none">
          <div class="row px-3">
            <div class="col-4 small">
              <strong>Producto</strong>
            </div>
            <div class="col-2 small">
              <label class="text-danger pl-3"></label>
            </div>
            <div class="col-1 small">
              <strong>Categoría</strong>
            </div>
            <div class="col-1 text-end small">
              <strong>Cantidad</strong>
            </div>
            <div class="col-2 text-end small"><strong>Precio</strong></div>
            <div class="col-2 text-end small">
              <strong>Importe parcial</strong>
            </div>
          </div>
        </div>
      </div>

      <CompraListItems
        v-for="(cart, index) in shoppingCartItems"
        :key="`cart_${index}`"
        :cart_item="cart"
        :index="index"
      />
      <div class="row justify-content-end px-4">
        <div class="col-12 total">
          Total: ${{ number_format(shoppingCartTotal) }}
        </div>
      </div>

      <div class="form-group row mx-3">
        <div
          class="col-md-6"
          style="
            display: flex;
            justify-content: flex-start;
            align-items: flex-end;
          "
        >
          <button class="btn standard-btn cancel-btn" @click.stop="onClose">
            Cerrar
          </button>
        </div>

        <div class="col-md-6 text-end"></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.total {
  text-align: end;
  color: green;
  font-weight: bold;
  font-size: 22px;
}
</style>
